import type Quill from '../core.js';

export default new WeakMap<Node, Quill>();



// WEBPACK FOOTER //
// ../../src/core/instances.ts